import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getActiveSalon } from 'Containers/Auth/store/selectors';
import { isDemoMode } from 'demo';
import styles from './DemoModeBanner.module.scss';

const DemoModeBanner = () => {
  const { t } = useTranslation();
  const salon = useSelector(getActiveSalon());
  if (!isDemoMode(salon)) return null;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.badge}>{t('common.demoMode.label')}</span>
      <span className={styles.message}>{t('common.demoMode.banner')}</span>
    </div>
  );
};

export default memo(DemoModeBanner);
